const listColumn = {
  TICKER: 'ticker',
  VOLUME: 'volume',
  PRICE: 'price',
  PERCENT_PRICE_CHANGE: 'percentPriceChange',
  FOREIGN_BUY_VOL: 'foreignBuyVolume',
  FOREIGN_BUY_VALUE: 'foreignBuyValue',
  FOREIGN_SELL_VOL: 'foreignSellVolume',
  FOREIGN_SELL_VALUE: 'foreignSellValue',
  PE: 'financial.rtd21',
  PB: 'financial.rtd25',
  BETA: 'financial.rtd19',
  RANKING: 'rank',
  TOTAL_RANK: 'totalRank',
  HIGH_PRICE: 'ceilingPrice',
  LOW_PRICE: 'floorPrice',
  REF_PRICE: 'referencePrice',
  CHANGE_PRICE: 'priceChange',
};

const listHideColumn = [
  'ceilingPrice',
  'floorPrice',
  'referencePrice',
  'priceChange',
  'foreignBuyVolume',
  'foreignBuyValue',
  'foreignSellVolume',
  'foreignSellValue',
  'totalRank',
];

export default {
  listColumn,
  listHideColumn,
};
